import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../api/api';

// ===============================================
// 🔥 ASYNC THUNKS - API Calls
// ===============================================

// ✅ Doping qiymətlərini əldə et
export const get_doping_prices = createAsyncThunk(
    'doping/get_doping_prices',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/doping-prices');
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Qiymətlər əldə edilmədi' });
        }
    }
);

// ✅ Doping əlavə et
export const add_doping = createAsyncThunk(
    'doping/add_doping',
    async (dopingData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/doping-add', dopingData, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping əlavə edilmədi' });
        }
    }
);

// ✅ Doping yenilə
export const update_doping = createAsyncThunk(
    'doping/update_doping',
    async (dopingData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put('/doping-update', dopingData, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping yenilənmədi' });
        }
    }
);

// ✅ Doping ləğv et
export const cancel_doping = createAsyncThunk(
    'doping/cancel_doping',
    async (dopingId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/doping-cancel', { dopingId }, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Doping ləğv edilmədi' });
        }
    }
);

// ✅ Seller-in doping tarixçəsi
export const get_seller_dopings = createAsyncThunk(
    'doping/get_seller_dopings',
    async ({ page = 1, limit = 10, status }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `/seller/dopings?page=${page}&limit=${limit}${status ? `&status=${status}` : ''}`,
                { withCredentials: true }
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Tarixçə əldə edilmədi' });
        }
    }
);

// ✅ Doping statistikası
export const get_doping_stats = createAsyncThunk(
    'doping/get_doping_stats',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/seller/doping-stats', { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Statistika əldə edilmədi' });
        }
    }
);

// ✅ Aktiv dopingli məhsullar (Client üçün)
export const get_active_dopings = createAsyncThunk(
    'doping/get_active_dopings',
    async ({ dopingType, page = 1, limit = 5 }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(
                `/active-dopings?${dopingType ? `dopingType=${dopingType}&` : ''}page=${page}&limit=${limit}`
            );
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Aktiv dopinqlər əldə edilmədi' });
        }
    }
);

export const get_weekly_deals = createAsyncThunk(
    'doping/get_weekly_deals',
    async (query = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const params = new URLSearchParams(query).toString();
            const { data } = await api.get(`/listings/featured/weekly${params ? `?${params}` : ''}`);
            return fulfillWithValue({ ...data, append: !!query.append });
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Həftənin fürsətləri yüklənmədi' });
        }
    }
);

export const get_daily_deals = createAsyncThunk(
    'doping/get_daily_deals',
    async (query = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const params = new URLSearchParams(query).toString();
            const { data } = await api.get(`/listings/featured/daily${params ? `?${params}` : ''}`);
            return fulfillWithValue({ ...data, append: !!query.append });
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Gunun firsetleri yuklenmedi' });
        }
    }
);

export const get_homepage_featured = createAsyncThunk(
    'doping/get_homepage_featured',
    async (query = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const params = new URLSearchParams(query).toString();
            const { data } = await api.get(`/listings/featured/home${params ? `?${params}` : ''}`);
            return fulfillWithValue({ ...data, append: !!query.append });
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Anasehife vitrini yuklenmedi' });
        }
    }
);

export const get_vitrine_products = createAsyncThunk(
    'doping/get_vitrine_products',
    async (query = {}, { rejectWithValue, fulfillWithValue }) => {
        try {
            const params = new URLSearchParams({ ...query, type: 'bumped' }).toString();
            const { data } = await api.get(`/home/query-products${params ? `?${params}` : ''}`);
            return fulfillWithValue({ ...data, append: !!query.append });
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Önə çıxarılan elanlar yüklənmədi' });
        }
    }
);

// ✅ Məhsulun aktiv dopinqi
export const get_product_active_doping = createAsyncThunk(
    'doping/get_product_active_doping',
    async (productId, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/product/${productId}/doping`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: 'Məhsul dopinqi tapılmadı' });
        }
    }
);

// ===============================================
// 🔥 REDUX SLICE
// ===============================================

export const dopingReducer = createSlice({
    name: 'doping',
    initialState: {
        // Loading states
        loader: false,
        dopingLoader: false,

        // Messages
        successMessage: '',
        errorMessage: '',

        // Data
        dopingPrices: null,
        dopings: [],
        activeDopings: [],
        currentDoping: null,
        stats: null,
        searchDopings: [],
        dailyDeals: [],
        homepageFeatured: [],
        vitrineProducts: [],
        weeklyDeals: [],
        weeklyPagination: null,
        dailyPagination: null,
        homepageFeaturedPagination: null,
        vitrinePagination: null,

        // Pagination
        totalDopings: 0,
        currentPage: 1,
        totalPages: 1,

        // Wallet
        remainingBalance: 0
    },

    reducers: {
        messageClear: (state) => {
            state.errorMessage = '';
            state.successMessage = '';
        },

        clearCurrentDoping: (state) => {
            state.currentDoping = null;
        }
    },

    extraReducers: (builder) => {
        builder
            // ===============================================
            // Get Doping Prices
            // ===============================================
            .addCase(get_doping_prices.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_doping_prices.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.dopingPrices = payload.prices;
            })
            .addCase(get_doping_prices.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Qiymətlər əldə edilmədi';
            })

            // ===============================================
            // Add Doping
            // ===============================================
            .addCase(add_doping.pending, (state) => {
                state.dopingLoader = true;
            })
            .addCase(add_doping.fulfilled, (state, { payload }) => {
                state.dopingLoader = false;
                state.successMessage = payload.message;
                state.remainingBalance = payload.remainingBalance;
                // Dopingi listə əlavə et
                if (payload.doping) {
                    state.dopings.unshift(payload.doping);
                    state.totalDopings += 1;
                }
            })
            .addCase(add_doping.rejected, (state, { payload }) => {
                state.dopingLoader = false;
                state.errorMessage = payload?.error || 'Doping əlavə edilmədi';
            })

            // ===============================================
            // Update Doping
            // ===============================================
            .addCase(update_doping.pending, (state) => {
                state.dopingLoader = true;
            })
            .addCase(update_doping.fulfilled, (state, { payload }) => {
                state.dopingLoader = false;
                state.successMessage = payload.message;
                state.remainingBalance = payload.remainingBalance;
                // Dopingi yenilə
                const index = state.dopings.findIndex(d => d._id === payload.doping._id);
                if (index !== -1) {
                    state.dopings[index] = payload.doping;
                }
            })
            .addCase(update_doping.rejected, (state, { payload }) => {
                state.dopingLoader = false;
                state.errorMessage = payload?.error || 'Doping yenilənmədi';
            })

            // ===============================================
            // Cancel Doping
            // ===============================================
            .addCase(cancel_doping.pending, (state) => {
                state.dopingLoader = true;
            })
            .addCase(cancel_doping.fulfilled, (state, { payload }) => {
                state.dopingLoader = false;
                state.successMessage = payload.message;
                state.remainingBalance = payload.remainingBalance;
                // Dopingi yenilə
                const index = state.dopings.findIndex(d => d._id === payload.doping._id);
                if (index !== -1) {
                    state.dopings[index] = payload.doping;
                }
            })
            .addCase(cancel_doping.rejected, (state, { payload }) => {
                state.dopingLoader = false;
                state.errorMessage = payload?.error || 'Doping ləğv edilmədi';
            })

            // ===============================================
            // Get Seller Dopings
            // ===============================================
            .addCase(get_seller_dopings.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_seller_dopings.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.dopings = payload.dopings;
                state.totalDopings = payload.total;
                state.currentPage = payload.page;
                state.totalPages = payload.pages;
            })
            .addCase(get_seller_dopings.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Tarixçə əldə edilmədi';
            })

            // ===============================================
            // Get Doping Stats
            // ===============================================
            .addCase(get_doping_stats.fulfilled, (state, { payload }) => {
                state.stats = payload;
            })

            // ===============================================
            // Get Active Dopings (Client)
            // ===============================================
            .addCase(get_active_dopings.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_active_dopings.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.activeDopings = payload.dopings;
                state.searchDopings = payload.dopings.filter(
                    d => ['arama_vitrini', 'search_featured'].includes(d.dopingType)
                );

                state.dailyDeals = payload.dopings.filter(
                    d => ['gunun_firsati', 'daily_deal'].includes(d.dopingType)
                );

                state.homepageFeatured = payload.dopings.filter(
                    d => ['anasayfa_vitrini', 'home_featured'].includes(d.dopingType)
                );
                state.weeklyDeals = payload.dopings.filter(
                    d => ['weekly_deal'].includes(d.dopingType)
                );
            })
            .addCase(get_active_dopings.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Aktiv dopinqlər əldə edilmədi';
            })

            // ===============================================
            // Get Product Active Doping
            // ===============================================
            .addCase(get_product_active_doping.fulfilled, (state, { payload }) => {
                state.currentDoping = payload.doping;
            })
            .addCase(get_product_active_doping.rejected, (state) => {
                state.currentDoping = null;
            })
            .addCase(get_weekly_deals.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_weekly_deals.fulfilled, (state, { payload }) => {
                state.loader = false;
                const next = payload.dopings || [];
                if (payload.append) {
                    const seen = new Set(state.weeklyDeals.map(item => (item.productId?._id || item._id)?.toString()));
                    state.weeklyDeals = [
                        ...state.weeklyDeals,
                        ...next.filter(item => {
                            const id = (item.productId?._id || item._id)?.toString();
                            if (!id || seen.has(id)) return false;
                            seen.add(id);
                            return true;
                        })
                    ];
                } else {
                    state.weeklyDeals = next;
                }
                state.weeklyPagination = payload.pagination || null;
            })
            .addCase(get_weekly_deals.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Həftənin fürsətləri yüklənmədi';
            })
            .addCase(get_daily_deals.fulfilled, (state, { payload }) => {
                const next = payload.dopings || [];
                state.dailyDeals = payload.append ? [...state.dailyDeals, ...next] : next;
                state.dailyPagination = payload.pagination || null;
            })
            .addCase(get_homepage_featured.fulfilled, (state, { payload }) => {
                const next = payload.dopings || [];
                if (payload.append) {
                    const seen = new Set(state.homepageFeatured.map(item => (item.productId?._id || item._id)?.toString()));
                    state.homepageFeatured = [
                        ...state.homepageFeatured,
                        ...next.filter(item => {
                            const id = (item.productId?._id || item._id)?.toString();
                            if (!id || seen.has(id)) return false;
                            seen.add(id);
                            return true;
                        })
                    ];
                } else {
                    state.homepageFeatured = next;
                }
                state.homepageFeaturedPagination = payload.pagination || null;
            })
            .addCase(get_vitrine_products.pending, (state) => {
                state.loader = true;
            })
            .addCase(get_vitrine_products.fulfilled, (state, { payload }) => {
                state.loader = false;
                const next = payload.dopings || payload.products || [];
                if (payload.append) {
                    const seen = new Set(state.vitrineProducts.map(item => (item.productId?._id || item._id)?.toString()));
                    state.vitrineProducts = [
                        ...state.vitrineProducts,
                        ...next.filter(item => {
                            const id = (item.productId?._id || item._id)?.toString();
                            if (!id || seen.has(id)) return false;
                            seen.add(id);
                            return true;
                        })
                    ];
                } else {
                    state.vitrineProducts = next;
                }
                state.vitrinePagination = payload.pagination || null;
            })
            .addCase(get_vitrine_products.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload?.error || 'Önə çıxarılan elanlar yüklənmədi';
            });
    }
});

export const { messageClear, clearCurrentDoping } = dopingReducer.actions;
export default dopingReducer.reducer;
